<template>
    <BasePage :loading="loading" :error="error" :params="params" style="overflow: hidden">
        <SotHeader label="Мои курсы" />
        <div class="q-pa-md base-page-content" style="padding-top: 50px">
            <div class="q-gutter-y-lg" style="margin-bottom: 0" v-show="!loading">
                <div v-for="(c, i) in courses" :key="i">
                    <SotButton :label="c.title" :params="{}" class="full-width" @click="openCourse(c)" />
                </div>
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import SotHeader from 'components/ui/design/SotHeader';
import SotButton from 'components/ui/design/SotButton';

export default {
    name: 'PageMyCourses',
    components: { SotButton, SotHeader, BasePage },
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    data () {
        return {
            loading: false,
            error: undefined,
            courses: undefined,
        };
    },
    mounted () {
        this.load();
    },
    methods: {
        load () {
            this.loading = true;
            this.$db.users.getMyBoughtCourses().then((courses) => {
                this.courses = courses;
                this.loading = false;
            });
        },
        openCourse (course) {
            this.$pages.push({
                to: 'course_page',
                course_id: course.course_id,
                label: course.title,
            });
        },
    },
};
</script>

<style scoped>

</style>
